import axios from 'axios';
import { periodsActions } from '../actions/periodsActions';
import { organizationConstants } from '../constants/organizationConstants';
import { periodsConstants, scenarioConstants } from '../constants';
import { getAccountStructure } from './accountActions';


export function getOrganization() {
    return async (dispatch) => {
        dispatch(request());

        try {
            const url = '/organization/';
            const response = await axios.get(url);
            const organization = response.data;

            if (response.status === 200) dispatch(success(organization));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to fetch organization at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: organizationConstants.GET_ORGANIZATION_REQUEST };
    }
    function success(organization) {
        return {
            type: organizationConstants.GET_ORGANIZATION_SUCCESS,
            organization,
        };
    }
    function failure(error) {
        return { type: organizationConstants.GET_ORGANIZATION_FAILURE, error };
    }
}

export function updateOrganization(
  organization,
  expandedPeriods,
  value,
  type,
  oldExpandedPeriods,
  targetYear
) {
  function request() {
    return { type: organizationConstants.UPDATE_ORGANIZATION_REQUEST };
  }

  function success(updatedOrganization) {
    return {
      type: organizationConstants.UPDATE_ORGANIZATION_SUCCESS,
      updatedOrganization,
    };
  }

  function failure(error) {
    return {
      type: organizationConstants.UPDATE_ORGANIZATION_FAILURE,
      error,
    };
  }

  function periodsSuccess(periods) {
    return { type: periodsConstants.SET_PERIODS_SUCCESS, periods };
  }

  function expandedPeriodsSuccess(expandedPeriods) {
    return {
      type: periodsConstants.SET_EXPANDED_PERIODS_SUCCESS,
      expandedPeriods,
    };
  }

  function scenarioSuccess() {
    return { type: scenarioConstants.SET_SCENARIOS_NULL_SUCCESS };
  }

  return async (dispatch) => {
    dispatch(request());

    try {
      const organizationUrl = '/organization/' + organization.organization_id;

      const response = await axios.put(
        organizationUrl,
        {
          organization,
          expandedPeriods,
          value,
          type,
          oldExpandedPeriods,
          targetYear,
        },
        {
          timeout: 150000,
        }
      );

      if (response.status === 200) {
        const updatedOrganization = response.data;

        if (updatedOrganization?.periods) {
          dispatch(periodsSuccess(updatedOrganization.periods));
        }

        /*
        * The account endpoint now returns
        * getDisplayAccountStructure(), including separators.
        */
        await dispatch(getAccountStructure());

        dispatch(scenarioSuccess());

        if (updatedOrganization?.organization) {
          dispatch(success(updatedOrganization.organization));
        }

        return updatedOrganization.organization; // allow chaining if needed
      }

      if (response.status === 500) {
        dispatch(failure(response.data.toString()));
      }
    } catch (error) {
      console.error(error);

      if (error.response) {
        dispatch(failure(error.response.data.toString()));
      } else if (error.code === 'ECONNABORTED') {
        dispatch(failure('Request timed out. Please try again later.'));
      } else {
        dispatch(failure('Unable to update organization at this moment. Please try again later.'));
      }
    }
  };
}


let isPollingExpandedPeriods = false;


export const pollUntilExpandedPeriodsReady = (orgId, retries = 1000, intervalMs = 3000) => {
  return async (dispatch) => {
    if (isPollingExpandedPeriods) {
      console.warn('Polling already in progress. Skipping duplicate.');
      return;
    }

    isPollingExpandedPeriods = true;

    dispatch({ type: 'EXPANDED_PERIODS_POLLING_START' });

    let attempts = 0;

    const poll = async () => {
      try {
        const { data: updatedStatus } = await axios.get(`/organization/${orgId}/status?_ts=${Date.now()}`, {
          headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
          },
        });

        const status = updatedStatus.change_period_status;

        if (status === 'completed') {
          await new Promise(resolve => setTimeout(resolve, 500));

          const organizationResponse = await axios.get(`/organization/`);
          const freshOrganization = organizationResponse.data;

          dispatch({ type: organizationConstants.GET_ORGANIZATION_SUCCESS, organization: freshOrganization });
          dispatch({ type: organizationConstants.UPDATE_ORGANIZATION_SUCCESS, updatedOrganization: freshOrganization });

          
          await dispatch(getAccountStructure()); // refresh accountStructure
         

          dispatch(periodsActions.getPeriods());
          dispatch(periodsActions.getExpandedPeriods());

          dispatch({ type: 'EXPANDED_PERIODS_POLLING_SUCCESS' });

          isPollingExpandedPeriods = false;

          window.location.reload(); // <-- maybe not needed anymore
        }
        
        else if (++attempts >= retries) {

          console.warn('Max retries reached. Job not completed.');
          
          dispatch({ type: 'EXPANDED_PERIODS_POLLING_TIMEOUT' });
          isPollingExpandedPeriods = false;
        } else {

        //console.log('⛔ Debug: Breaking before scheduling next poll');
        // debugger;
          console.log(`Still processing... (Attempt ${attempts}/${retries})`);
          setTimeout(poll, intervalMs); // schedule next poll
        }
      } catch (err) {
        isPollingExpandedPeriods = false;
        if (err.response?.status === 401) {
          console.warn('Session expired. Redirecting to login.');
         window.location.href = '/auth';

        } else {
          console.error('Unexpected polling error:', err);
          dispatch({ type: 'EXPANDED_PERIODS_POLLING_ERROR' });
        }
      }
    };

    poll(); // Start polling
  };
};

export function updateBaseCurrency(id) {
    return async (dispatch) => {
        dispatch(request());

        try {
            const url = '/organization/base-currency/' + id;
            const response = await axios.put(url);

            if (response.status === 200) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to update organization at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: organizationConstants.UPDATE_BASE_CURRENCY_REQUEST };
    }
    function success(organization) {
        return {
            type: organizationConstants.UPDATE_BASE_CURRENCY_SUCCESS,
            organization,
        };
    }
    function failure(error) {
        return {
            type: organizationConstants.UPDATE_BASE_CURRENCY_FAILURE,
            error,
        };
    }
}
/*might not be used anymore*/
export const triggerChangeViaJob = (type, value, targetYear) => async (dispatch, getState) => {
  const state = getState();
  const organization = state.organization.organization;

  const response = await fetch('/api/trigger-periods-job', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      organizationId: organization.organization_id,
      type,
      value: Number(value),
      targetYear,
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to start background job');
  }

  // Start polling for job completion
  dispatch(pollUntilExpandedPeriodsReady(organization.organization_id));
};

export const organizationActions = {
    getOrganization,
    updateOrganization,
    updateBaseCurrency,
    pollUntilExpandedPeriodsReady,
};